<template>
  <div class="scene scene--europe europe-scene">
    <div v-if="!selectedCase" class="subbrand-logo">
      <router-link to="/"><img src="images/subbrand-logo.svg" /></router-link>
    </div>

    <div v-if="!selectedCase" class="corner-logos">
      <img src="images/corner-logos.png" />
    </div>
    <template v-if="!backgroundIsTransitioning">
      <router-link
        v-if="!selectedCase"
        to="/challenges/"
        class="europe-scene__back-btn close-button close-button--left close-button--icon-back"
        >Back</router-link
      >
      <div class="europe-map">
        <!-- <div class="debug-output-for-video-issue-toggle" @click="tempShowDebugOutput = !tempShowDebugOutput"></div> -->

        <template v-if="selectedDataLayer">
          <!--<div v-if="tempShowDebugOutput" class="debug-output-for-video-issue" v-html="tempDebugOutput"></div>-->

          <!-- NOTE(Mølby): Video layer -->
          <div>
            <!-- <img :src="mediaUrl(selectedDataLayer.backgroundImage)" class="europe-map__layer-image"/>
            <video 
              ref="overlayVideo"
              :src="mediaUrl(selectedDataLayer.backgroundVideo)" 
              class="europe-map__layer-video"
              :class="{'europe-map__layer-video--is-playing': overlayVideoIsPlaying}"
              muted
              loop
              playsinline
              webkit-playsinline
              type="video/mp4"
              @contextmenu.prevent=""></video> -->

            <!-- <div class="europe-scene__markers">
              <div
                v-for="dataPoint in selectedDataLayer.dataPoints"
                v-bind:key="dataPoint.heading"
                class="europe-scene__hotspot"
                :class="{'europe-scene__hotspot--debug': dataPoint.showDebugOutline}"
                :style="'left: '+dataPoint.positionX+'px; top:'+dataPoint.positionY+'px; width:'+dataPoint.width+'px; height:'+dataPoint.height+'px;'">
                  <div class="europe-scene__hotspot-marker-popup eu-marker-popup" :class="[popupDirectionModifier(dataPoint.popupDirection), 'eu-marker-popup--'+selectedChallenge.colorTheme, {'eu-marker-popup--has-image': dataPoint.image}]">
                    <div class="eu-marker-popup__media">
                      <img v-if="dataPoint.image" :width="dataPoint.image.width" :height="dataPoint.image.height" :src="mediaUrl(dataPoint.image)" />
                    </div>
                    <div class="eu-marker-popup__heading">{{dataPoint.heading}}</div>
                    <div class="eu-marker-popup__sub-heading">{{dataPoint.subHeading}}</div>
                    <div class="eu-marker-popup__text" v-if="dataPoint.text" v-html="dataPoint.text"></div>
                  </div>
                </div>
            </div> -->
          </div>
        </template>

        <div
          v-if="selectedChallenge && !selectedCase && !selectedDataLayer"
          class="europe-scene__markers"
        >
          <Markers
            :markers="caseMarkersToDisplay"
            @markerClicked="handleMarkerClicked"
            :markerMergeRadius="50"
            :pointAtWhichPopupsShouldDrawUpward="600"
          />
        </div>
      </div>

      <div
        v-if="!selectedCase && !selectedDataLayer"
        class="europe-scene__challenges challenges"
      >
        <div class="challenges__heading" v-html="challengesHeading"></div>
        <div class="challenges__list" v-if="challengesEU.length">
          <template v-for="(challenge, i) in challengesEU" v-bind:key="i">
            <router-link
              :to="'/europe/' + challenge.id"
              class="challenges__item"
              :class="[
                {
                  'challenges__item--selected':
                    $route.params.challengeId == challenge.id,
                },
                'challenges__item--' + challenge.colorTheme,
              ]"
            >
              <span>{{ challenge.challengeName }}</span>
            </router-link>
          </template>
        </div>
        <div class="challenges__text-below">{{ textBelowChallenges }}</div>
      </div>
      <div
        v-if="selectedFact && selectedFact.small"
        class="eu-fact--small"
        @click="factsClicked = true"
        :class="[
          'eu-fact--' + selectedChallenge.colorTheme,
          `eu-fact--${factsClicked}`,
        ]"
        :style="{ cursor: factsClicked ? 'default' : 'pointer' }"
      >
        <div
          v-if="factsClicked"
          @click.stop="factsClicked = false"
          class="eu-fact__close-btn"
        >
          x
        </div>
        <div class="eu-fact__heading">
          {{ selectedFact.heading }}
          <svg
            class="fact__Open--icon"
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            viewBox="0 0 12 12"
          >
            <path
              id="Path_1704"
              data-name="Path 1704"
              d="M18,7.5v12"
              transform="translate(-12 -7.5)"
             
            />
            <path
              id="Path_1705"
              data-name="Path 1705"
              d="M7.5,18h12"
              transform="translate(-7.5 -12)"
             
            />
          </svg>
        </div>
        <div
          class="eu-fact__content--wrapper"
          :style="{
            height: factsClicked ? '320px' : '0px',
            opacity: factsClicked ? 1 : 0,
          }"
        >
          <div class="eu-fact__content" v-html="selectedFact.text"></div>
        </div>
      </div>
      <div
        v-if="selectedFact && !selectedFact.small"
        :class="[
          'fact--' + selectedChallenge.colorTheme,
          'fact--' + factsClicked,
        ]"
        class="factEuBig"
        @click="factsClicked = true"
        :style="{ cursor: factsClicked ? 'default' : 'pointer' }"
      >
        <div v-for="(fact, index) in factsEuBig" :key="index">
          <div v-if="fact.challengeId == $route.params.challengeId">
            <div class="facts__btn" v-if="!factsClicked">
              {{ fact.buttonText
              }}<img
                class="fact__Open--icon"
                src="images/europe/Icon_plus.png"
              />
              
            </div>
            <section class="facts__content" v-if="factsClicked">
              <img class="facts__logo" src="images/europe/sog_logo.png" />
              <article class="facts__heading">
                <h1>{{ fact.heading }}</h1>
                <p>{{ fact.subheading }}</p>
              </article>
              <section class="factInfo__container">
                <img class="factInfo__image" :src="mediaUrl(fact.image)" />
                <div class="factInfo__content">
                  <div class="factInfo__text">
                    <h2>{{ fact.infoBoxHeading }}</h2>
                    <p v-bind:innerHTML="fact.infoBoxContent"></p>
                  </div>
                </div>
              </section>
              <section
                v-if="fact.factArea.length >= 1"
                class="factBoxArea_container"
              >
                <div v-for="(factArea, index) in fact.factArea" :key="index">
                  <div class="factBoxArea__item">
                    <h2>{{ factArea.bigFact }}</h2>
                    <p>{{ factArea.smallFact }}</p>
                  </div>
                </div>
              </section>
              <section class="factCaseArea" v-if="fact.caseArea.length >= 1">
                <div
                  v-for="(caseArea, index) in fact.caseArea"
                  :key="index"
                  class="factCaseArea__container"
                >
                  <div class="factCaseArea__item">
                    <img :src="mediaUrl(caseArea.icon)" alt="icon" />
                    <div class="factCaseArea__text">
                      <h2 class="factCase__title">{{ caseArea.title }}</h2>
                      <p class="factCase__description">
                        {{ caseArea.description }}
                      </p>
                      <div
                        class="eu-case-link"
                        @click="openIframeOverlay(caseArea.link)"
                      >
                        <p>Cases & solution providers</p>
                        <svg
                          class="case_link_icon"
                          xmlns="http://www.w3.org/2000/svg"
                          width="9.33"
                          height="15.109"
                          viewBox="0 0 9.33 15.109"
                        >
                          <path
                            class="case_link_icon"
                            d="M1.775,0,7.555,5.767,13.334,0l1.775,1.775L7.555,9.33,0,1.775Z"
                            transform="translate(0 15.109) rotate(-90)"
                            fill="#fff"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <div class="fact__close-btn" @click.stop="factsClicked = false">
                CLOSE <span>X</span>
              </div>
              <div v-if="showIframeOverlay" class="iframe-overlay">
                <button class="iframe-close-button" @click="closeIframeOverlay">
                  X
                </button>
                <iframe
                  :src="iframeUrl"
                  frameborder="0"
                  class="iframe-content"
                ></iframe>
              </div>
            </section>
          </div>
        </div>
      </div>
      <div class="disclaimer-right" v-html="mapDisclaimer"></div>
    </template>
  </div>
</template>
<script>
import store from "@/dataStore";
import Markers from "@/components/Markers";
//  import CaseOverlay from '@/components/CaseOverlay';
import config from "@/config.js";
import * as Vue from "vue";
import eventBus from "@/helpers/eventBus";

export default {
  name: "Europe",
  components: {
    //  CaseOverlay: CaseOverlay,
    Markers: Markers,
  },

  data() {
    return {
      iframeUrl: "",
      showIframeOverlay: false,
      isLoading: false,
      challengesEU: [],
      casesEU: [],
      factsClicked: false,
      dataLayersEU: [],
      factsEuSmall: [],
      mapDisclaimer: "",
      selectedDataLayer: null,
      selectedMarkerId: null,
      selectedFactId: null,
      selectedFact: null,
      backgroundIsTransitioning: false,
      overlayVideoIsPlaying: false,
      // NOTE(Mølby): Text strings
      factsAbouteuButtonText: "",
      challengesHeading: "",
      textBelowChallenges: "",
      challengesPageViewCaseLinkText: "",

      // NOTE(Mølby): Datapoint popup
      selectedRegionPosition: { x: 0, y: 0 },
      selectedRegionId: null,
    };
  },
  mounted() {},
  methods: {
    openIframeOverlay(url) {
      // Ensure the URL is absolute
      if (!url.startsWith("http://") && !url.startsWith("https://")) {
        url = "https://" + url; // Prepend https:// if missing
      }
      this.iframeUrl = url;
      this.showIframeOverlay = true;
    },
    closeIframeOverlay() {
      this.showIframeOverlay = false;
      this.iframeUrl = "";
    },
    handleMapRegionMouseEnter(event) {
      var regionId = event.currentTarget.getAttribute("id");
      this.selectedRegionId = regionId;

      var elementClientRect = event.currentTarget.getBoundingClientRect();
      var scaleInfo = this.appClientScaleInfo();

      var elementPosition = {
        x:
          (elementClientRect.x - scaleInfo.offsetLeft) /
          scaleInfo.scaleDifference,
        y:
          (elementClientRect.y - scaleInfo.offsetTop) /
          scaleInfo.scaleDifference,
        width: elementClientRect.width / scaleInfo.scaleDifference,
        height: elementClientRect.height / scaleInfo.scaleDifference,
      };

      this.selectedRegionPosition = {
        x: elementPosition.x + elementPosition.width,
        y: elementPosition.y + elementPosition.height / 2,
      };
    },
    handleMapRegionMouseLeave() {
      this.selectedRegionId = null;
    },
    popupDirectionModifier(directionString) {
      if (directionString === "Top") {
        return "eu-marker-popup--top";
      }
      if (directionString === "Right") {
        return "eu-marker-popup--right";
      }
      if (directionString === "Right Upward") {
        return "eu-marker-popup--right-upward";
      }
      if (directionString === "Down") {
        return "eu-marker-popup--down";
      }
      if (directionString === "Left") {
        return "eu-marker-popup--left";
      }
      if (directionString === "Left Upward") {
        return "eu-marker-popup--left-upward";
      }
      return "";
    },
    appClientScaleInfo() {
      var appElement = document.querySelector(".aspect-ratio");
      var appBounds = appElement.getBoundingClientRect();

      return {
        scaleDifference: parseFloat(appElement.getAttribute("data-scale")),
        offsetLeft: appBounds.x,
        offsetTop: appBounds.y,
      };
    },
    mediaUrl(mediaItem) {
      console.log("mediaItem", mediaItem);
      var url = config.umbracoMediaPath + mediaItem.src;
      return url;
    },
    handleMarkerClicked(markerInfo) {
      if (!markerInfo || this.selectedMarkerId === markerInfo.id) {
        this.selectedMarkerId = null;
      } else {
        this.selectedMarkerId = markerInfo.id;
      }
    },
    calcMarkerPosition(coordinates) {
      var position = { x: 0, y: 0 };

      const mapTopLeftCoordinates = { lat: 63.88, long: -35.87 }; // Top-left corner
      const mapBottomRightCoordinates = { lat: 24.49, long: 65.92 }; // Bottom-right corner

      const longitudeRange =
        mapBottomRightCoordinates.long - mapTopLeftCoordinates.long;
      const latitudeRange =
        mapTopLeftCoordinates.lat - mapBottomRightCoordinates.lat;

      // NOTE(Mølby): Convert global coordinates to positions on the EU map
      var lat = 0;
      var long = 0;
      var coordinatesSplit = coordinates.split(",");
      if (coordinatesSplit.length === 2) {
        lat = coordinatesSplit[0];
        long = coordinatesSplit[1];
      }

      // NOTE(Mølby): Tweak these for accuracy...

      const mapBottomLeftCoordinates = { lat: 32.9, long: -26.17 };
      const mapScaleX = 1920 / longitudeRange;
      const mapScaleY = 1080 / latitudeRange;

      var xPos = (long - mapBottomLeftCoordinates.long) * mapScaleX;
      var yPos = 1080 - (lat - mapBottomLeftCoordinates.lat) * mapScaleY;
      position = {
        x: xPos,
        y: yPos,
        opacity: 1,
        pointerEvents: "pointer-events:all",
      };

      return position;
    },
    selectDataLayer(dataLayer) {
      if (this.selectedDataLayer === dataLayer) {
        this.selectedDataLayer = null;
      } else {
        this.selectedDataLayer = dataLayer;
      }
    },
  },
  computed: {
    caseMarkersToDisplay() {
      var result = [];

      this.casesEU.forEach((challengeCase) => {
        if (
          challengeCase.challengeId === parseInt(this.$route.params.challengeId)
        ) {
          result.push({
            id: challengeCase.id,
            type: "case",
            positionInfo: this.calcMarkerPosition(
              challengeCase.locationCoordinates
            ),
            colorTheme: this.selectedChallenge.colorTheme,
            showPopupContent: challengeCase.id === this.selectedMarkerId,
            euCaseData: { ...challengeCase },
            popupLinkRouterTo:
              "/europe/" +
              this.selectedChallenge.id +
              "/" +
              challengeCase.id +
              "/",
          });
        }
      });
   
      return result;
    },
    selectedDataPoint() {
      var regionDataFound = null;

      if (this.selectedDataLayer && this.selectedDataLayer.dataPoints) {
        this.selectedDataLayer.dataPoints.forEach((dataPoint) => {
          if (dataPoint.municipalityID === this.selectedRegionId) {
            regionDataFound = dataPoint;
          }
        });
      }
      return regionDataFound;
    },
    selectedChallenge() {
  let result = null;

  if (this.$route.params.challengeId) {
    this.challengesEU.forEach((challenge) => {
      if (challenge.id == this.$route.params.challengeId) {
        result = challenge;
      }
    });
  }

  return result;
},
    selectedCase() {
      var result = null;

      if (this.$route.params.caseId) {
        this.casesEU.forEach((challengeCase) => {
          if (challengeCase.id == this.$route.params.caseId) {
            result = challengeCase;
          }
        });
      }

      return result;
    },
  },
  created() {
    this.unsubscribeFromStore = store.subscribe((storeState) => {
      this.isLoading = storeState.isLoading;
      this.challengesEU = storeState.challengesEU;
      this.casesEU = storeState.casesEU;
      this.dataLayersEU = storeState.dataLayersEU;
      this.factsEuSmall = storeState.factsEuSmall;
      this.factsEuBig = storeState.factsEuBig;
      this.mapDisclaimer = storeState.siteInfo.mapDisclaimer;
      this.challengesHeading = storeState.europeInfo.challengesHeading;
      this.textBelowChallenges = storeState.europeInfo.textBelowChallenges;
    });

    if (!store.state.manifestIsLoaded) {
      store.loadManifest();
    }
  },
  watch: {
 
    selectedChallenge(newValue) {
      if (newValue) {
      const smallFact = this.factsEuSmall.find(
        (fact) => fact.challengeId == this.$route.params.challengeId
      );

      if (smallFact) {
        this.selectedFact = { ...smallFact, small: true };
      } else {
        const bigFact = this.factsEuBig.find(
          (fact) => fact.challengeId == this.$route.params.challengeId
        );
        this.selectedFact = { ...bigFact, small: false };
      }
    } else {
      this.selectedFact = null;
    }
      this.factsClicked = false; // Reset factsClicked when selectedChallenge changes
    },
    $route() {
      // NOTE(Mølby): Clear datalayer
      this.selectedDataLayer = null;
    },
    selectedDataLayer(newValue) {
      if (!newValue) {
        // NOTE: Start bg video (maybe it prevents playback of overlay video on "clevertouch" screeen?)
        Vue.nextTick(() => {
          eventBus.emit("background.startVideo");
        });
      } else {
        // NOTE: Stop bg video (maybe it prevents playback of the other video?)
        eventBus.emit("background.stopVideo");

        this.overlayVideoIsPlaying = false;

        // NOTE: Ensure video autoplay (Implemented manually here because certain android touchscreen ("clevertouch")
        // have issues with autoplaying the video consistently)
        Vue.nextTick(() => {
          var video = this.$refs.overlayVideo;

          // TODO: DELETE
          // this.tempDebugOutput = "<div>DEBUG INFO:</div>";

          if (video) {
            // this.tempDebugOutput = "<div>video element found...</div>";

            // NOTE: Tell the video to play when ready
            video.oncanplaythrough = () => {
              // this.tempDebugOutput += "<div>video.oncanplaythrough</div>"; // TODO: DELETE
              if (video.paused) {
                // this.tempDebugOutput += "<div>starting video...</div>"; // TODO: DELETE
                video.muted = true;
                video.play();
              }
            };

            video.onplay = () => {
              // this.tempDebugOutput += "<div>video.onplay</div>"; // TODO: DELETE
              // NOTE: Display video once it has been started successfully
              this.overlayVideoIsPlaying = true;
            };

            /* todo delete    
            video.onerror = () => {
              this.tempDebugOutput += "<div>"+video.error.code+"</div>"; // TODO: DELETE
              this.tempDebugOutput += "<div>"+video.error.message+"</div>"; // TODO: DELETE
            }

            video.oncanplay = () => {this.tempDebugOutput += "<div>oncanplay</div>";};
            video.oncomplete = () => {this.tempDebugOutput += "<div>oncomplete</div>";};
            video.onondurationchange = () => {this.tempDebugOutput += "<div>onondurationchange</div>";};
            video.onemptied = () => {this.tempDebugOutput += "<div>onemptied</div>";};
            video.onloadeddata = () => {this.tempDebugOutput += "<div>onloadeddata</div>";};
            video.onloadedmetadata = () => {this.tempDebugOutput += "<div>onloadedmetadata</div>";};
            video.onpause = () => {this.tempDebugOutput += "<div>onpause</div>";};
            video.onplaying = () => {this.tempDebugOutput += "<div>onplaying</div>";};
            video.onprogress = () => {this.tempDebugOutput += "<div>onprogress</div>";};
            video.onratechange = () => {this.tempDebugOutput += "<div>onratechange</div>";};
            video.onseeked = () => {this.tempDebugOutput += "<div>onseeked</div>";};
            video.onseeking = () => {this.tempDebugOutput += "<div>onseeking</div>";};
            video.onstalled = () => {this.tempDebugOutput += "<div>onstalled</div>";};
            video.onsuspend = () => {this.tempDebugOutput += "<div>onsuspend</div>";};
            video.ontimeupdate = () => {this.tempDebugOutput += "<div>ontimeupdate</div>";};
            video.onvolumechange = () => {this.tempDebugOutput += "<div>onvolumechange</div>";};
            video.onwaiting = () => {this.tempDebugOutput += "<div>onwaiting</div>";};
            video.onaudioprocess = () => {this.tempDebugOutput += "<div>onaudioprocess</div>";};

            */
          }
        });
      }
    },
  },
  unmounted() {
    this.unsubscribeFromStore();
  },
};
</script>
